import { Box, Tooltip, Typography, styled, useTheme } from "@mui/material";
import { CopyableText } from "components/CopyableText";
import { GetCredentialQuery } from "generated-graphql/graphql";

const TruncatedText = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CredentialPortalUrl = ({
  facility,
  credentialId,
}: {
  facility?: NonNullable<
    GetCredentialQuery["credential"]["facilities"]
  >[number];
  credentialId?: string;
}) => {
  const theme = useTheme();

  if (!credentialId) {
    return null;
  }

  const portalUrl = facility?.portalCredentials?.find(
    (pc) => pc.credential?.id === credentialId
  )?.url;

  return (
    <Box
      paddingTop={theme.spacing(1)}
      paddingBottom={theme.spacing(2)}
      display="flex"
      flexWrap="nowrap"
      maxWidth={theme.spacing(40)}
    >
      <Typography fontWeight="bold" paddingRight={theme.spacing(0.5)}>
        URL:
      </Typography>
      {portalUrl ? (
        <>
          <Tooltip title={portalUrl}>
            <TruncatedText>{portalUrl}</TruncatedText>
          </Tooltip>
          <CopyableText hideText>{portalUrl}</CopyableText>
        </>
      ) : (
        "N/A"
      )}
    </Box>
  );
};
